/**
<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
**/
/* HPX-348 */
  const maxDuration = 2 * 60 * 1000; // 2 minutes in milliseconds
  const intervalTime = 500; // check every 500ms
  let elapsedTime = 0;

  const checkFlyout = setInterval(() => {
    elapsedTime += intervalTime;

    const flyout = document.querySelector('[data-testid="FLYOUT"]');
    if (flyout) {      
      const firstInput = flyout.querySelector('input');
      const firstname = firstInput.id;
      const inputField = document.getElementById(firstname);      
      if (inputField) {
        inputField.focus(); 
        clearInterval(checkFlyout); // Stop checking once done
      }
    }
    // Stop checking after 2 minutes
    if (elapsedTime >= maxDuration) {
      clearInterval(checkFlyout);
    }
  }, intervalTime);
  
/* HPX-348 */
